/**
 * エラー判定のユーティリティ関数
 */

/**
 * AbortErrorかどうかを判定する
 */
export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}
